<template>
  <div>
    <el-dialog
      :title="$t('Hadisə_statusları')"
      :visible.sync="showModal"
      width="50%"
      top="5vh"
      append-to-body
    >
      <div>
        <accident-status
          v-if="showModal"
          :type="type"
          :id="accidentId"
          :key="`${accidentId}-${type}`"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showModal = false">
          {{$t('İmtina')}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AccidentStatus from "./AccidentStatus.vue";

export default {
  data() {
    return {
      showModal: false,
      accidentId: null,
      type: null, 
    };
  },
  components: {
    AccidentStatus,
  },
  methods: {
    view(id, type) {
      this.accidentId = id;
      this.type = type; 
      this.showModal = true;
    },
  },
};
</script>
